import { XF } from "./XF";

export function getBrowser() {
  const ua = navigator.userAgent.toLowerCase();
  let match: string[] | null = /trident\/.*rv:([0-9.]+)/.exec(ua);
  let browser: (typeof XF)["browser"];
  if (match) {
    browser = {
      browser: "msie",
      version: parseFloat(match[1]),
    };
  } else {
    // this is different regexes as we need the particular order
    match =
      /(msie)[ /]([0-9.]+)/.exec(ua) ||
      /(edge)[ /]([0-9.]+)/.exec(ua) ||
      /(chrome)[ /]([0-9.]+)/.exec(ua) ||
      /(webkit)[ /]([0-9.]+)/.exec(ua) ||
      /(opera)(?:.*version|)[ /]([0-9.]+)/.exec(ua) ||
      (ua.indexOf("compatible") < 0 &&
        /(mozilla)(?:.*? rv:([0-9.]+)|)/.exec(ua)) ||
      [];

    if (match[1] === "webkit" && ua.indexOf("safari")) {
      const safariMatch = /version[ /]([0-9.]+)/.exec(ua);
      if (safariMatch) {
        match = [match[0], "safari", safariMatch[1]];
      }
    }

    browser = {
      browser:
        (
          {
            msie: "msie",
            edge: "edge",
            chrome: "chrome",
            webkit: "webkit",
            opera: "opera",
            mozilla: "mozilla",
            safari: "safari",
          } as const
        )[match[1]] || "",
      version: parseFloat(match[2]) || 0,
    };
  }

  if (browser.browser) {
    browser[browser.browser] = true;
  }

  let os: (typeof browser)["os"] = "";
  let osVersion = null;
  let osMatch;

  if (/(ipad|iphone|ipod)/.test(ua)) {
    os = "ios";
    osMatch = /os ([0-9_]+)/.exec(ua);
    if (osMatch) {
      osVersion = parseFloat(osMatch[1].replace("_", "."));
    }
  } else {
    osMatch = /android[ /]([0-9.]+)/.exec(ua);
    if (osMatch) {
      os = "android";
      osVersion = parseFloat(osMatch[1]);
    } else if (/windows /.test(ua)) {
      os = "windows";
    } else if (/linux/.test(ua)) {
      os = "linux";
    } else if (/mac os/.test(ua)) {
      os = "mac";
    }
  }

  browser.os = os;
  browser.osVersion = osVersion;
  if (os) {
    browser[os] = true;
  }

  return browser;
}
